import IconButton, {IconType} from "./IconButton";
export {IconType};
export default IconButton;
